import { useFieldMetadata } from './useFieldMetadata';

export function useFieldMinWidth(id: string): number {
  const fieldMetadata = useFieldMetadata(id);
  return fieldMetadata?.minWidth ?? 0;
}

export function useFieldMaxWidth(id: string): number {
  const fieldMetadata = useFieldMetadata(id);
  return fieldMetadata?.maxWidth ?? 0;
}
